<template>
  <Modal>
    <Modal.Title>Privacy controls</Modal.Title>
    <Modal.Body>
      <UpgradeToProCallout v-if="isBasic" class="mb-5">
        Enable privacy/invite controls and other features
      </UpgradeToProCallout>

      <div :class="containerClasses">
        <div class="mb-4 text-gray-800">
          <div
            class="mb-1 flex items-center font-medium text-[14px] leading-[18px]"
          >
            <LockIcon class="mr-2 size-5 text-gray-800" />
            <div>Control file visibility</div>
          </div>
          If private, only you and those you invite can see the selected file(s)
          and its description
        </div>

        <Select
          v-model="visibility"
          size="xl"
          label="Select file visibility"
          :items="privacyOptions"
          :disabled="loading"
        />
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading || isBasic" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="isBasic"
        :loading="loading"
        @click="save"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, Select, useModal } from '@dacr/library'
import { LockIcon } from '@dacr/icons'
import UpgradeToProCallout from '@/features/billing/components/UpgradeToProCallout.vue'
import { useUpdateFilePrivacy, privacyOptions } from './useUpdateFilePrivacy'

const { close } = useModal()

const props = defineProps<{
  ids: string[]
}>()

const { isBasic, visibility, loading, save } = useUpdateFilePrivacy(
  props.ids,
  close
)

const containerClasses = computed(() => ({
  'pointer-events-none opacity-50': isBasic.value,
}))
</script>
